import { Provider } from '@angular/core';

import { CoverageApiService } from './coverage-api.service';
import { CoverageHttpService } from './coverage-http.service';

/** Registra la implementación de `CoverageApiService` que usa la app. */
export function provideCoverage(): Provider[] {
  return [{ provide: CoverageApiService, useClass: CoverageHttpService }];
}
